module.exports = __webpack_public_path__ + "static/media/anchorage.b13ea1dd.svg";